import {Directive, HostListener, Inject, Input, LOCALE_ID} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[inputNumber]',
})
export class InputNumberFormatDirective {
  @Input() maxLengthNumber: number = 18;
  @Input() isFistZero: boolean = true;
  @Input() isPaste: boolean = true;
  @Input() maxVal!: number;
  @Input() minVal!: number;
  @Input() vssPattern: RegExp = /[^0-9.]/g;


  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private control: NgControl,
  ) {
  }

  get decimalSeparator() {
    const numberFormat = new Intl.NumberFormat(this.locale);
    return numberFormat.format(1.1).charAt(1);
  }

  get commandNumber() {
    const numberFormat = new Intl.NumberFormat(this.locale);
    return numberFormat.format(1000).charAt(1);
  }

  lastValue = ''

  @HostListener('keydown', ['$event']) onKeyDown(event: any) {
    if (['Backspace', 'Enter', 'CapsLock'].includes(event.key)) {
      // this.lastValue = cloneDeep(event.target.value)
    }
    return this.validateNumber(event)
  }

  @HostListener('keyup', ['$event']) onKeyUp(event: any) {
   return this.validateNumber(event)
  }

  @HostListener('keypress', ['$event']) onKeyPress(event: any) {
   return this.validateNumber(event)
  }

  validateNumber(event: any) {
    if(event?.key?.length > 1 || event.ctrlKey) return
    if (event.target?.value?.length >= this.maxLengthNumber && event.target?.selectionStart == event.target?.selectionEnd) {
      event.preventDefault()
      return
    }
    let charCode = event.key
    if (this.vssPattern.test(charCode)) {
      event.preventDefault();
      return false
    } else {
      if (this.isFistZero) {
        return true;
      } else {
        return !(!this.control.control?.value && event.charCode === 48);
      }
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(event: any) {
    const v = this.control.control?.value
    if ((this.minVal || this.minVal === 0) && (!v || this.minVal > v)) {
      this.control.control?.setValue(this.minVal)
    } else if ((this.maxVal || this.maxVal === 0) && (!v || this.maxVal < v)) {
      this.control.control?.setValue(this.maxVal)
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: any) {
    if (!this.isPaste) {
      event.preventDefault()
      return false;
    }
    const pastedText: string = (event?.clipboardData?.getData('text') || '').replace(new RegExp(this.commandNumber == ',' ? ',' : '\\.', 'g'), '');
    if (pastedText && !Number(pastedText) || Number(pastedText) < 0 || Number(pastedText) % 1 !== 0) {
      event.preventDefault()
      return false;
    } else {
      let value = this.control.control?.value ? `${this.control.control?.value}` : ''
      const inputEl = event.target
      value = `${value.slice(0, inputEl.selectionStart)}${pastedText?.trim()}${value.slice(inputEl.selectionEnd, value.length)}`
      if (this.isFistZero) {
        this.control.control?.setValue(value)
      } else {
        this.control.control?.setValue(Number(value))
      }
      return false;
    }
  }

}
